import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { STATES_COLUMNS } from './columnConstants';
import { referenceDataDefaults } from './queryHelpers';

export interface StateRecord {
  id: number;
  code: string;
  name: string;
}

async function fetchStates(): Promise<StateRecord[]> {
  const { data, error } = await supabase.from('states').select(STATES_COLUMNS).order('name');

  if (error) {
    throw new Error(`Failed to fetch states: ${error.message}`);
  }

  return data ?? [];
}

/**
 * Hook for fetching all states. Returns { id, code, name } sorted by name.
 * Uses reference-data cache defaults (30 min stale, 1 hour GC).
 */
export function useStatesV2() {
  return useQuery({
    queryKey: ['states-v2'],
    queryFn: fetchStates,
    ...referenceDataDefaults,
  });
}
